module.exports = __webpack_public_path__ + "assets/img/qyzx_qy_bn.f1d1f581.png";